let enabledFeaturesMap = window.__GENERATED_CONSTANTS__.EnabledFeatures

/**
 * @deprecated use instade unsafe_selectWithStore(isFeatureEnabledSelector)
 * @param feature
 * @returns {boolean}
 */
export function isEnabled(feature) {
    return !!enabledFeaturesMap[feature]
}

export function getEnabledFeaturesMap() {
    return enabledFeaturesMap
}

export function setEnabledFeaturesMap(featuresMap) {
    enabledFeaturesMap = featuresMap
}


// WEBPACK FOOTER //
// ./web/js/features/enabledFeatures.js